export default __webpack_public_path__ + "static/media/a019-tip.32bcb7bd.jpg";